module.exports = __webpack_public_path__ + "img/img-3-2.7f88c834.png";